import { Grid } from "@mui/material";
import arrayMutators from "final-form-arrays";
import Layout from "../../../components/Layout";
import LoadingBoundary from "../../../components/LoadingBoundary";
import Snack from "../../../components/Snack";

import { Form } from "react-final-form";
import { useNavigate } from "react-router";
import Libelle from "../../../_i18n/fr.json";
import { transformUtilisateurDataToModel } from "../helpers";
import UtilisateurAdbForm, {
  UtilisateurFormData,
  validateForm,
} from "../UtilisateurAdbForm";
import { buildInitialValues, renderAdbList } from "./helpers";
import { useModifierUtilisateur } from "./selectors";

function ModifierUtilisateurAdb() {
  const {
    fonctionsPostes,
    adbRegroupementList,
    modifierUtilisateur,
    adbSelectedDetail,
    fonctionsPostesError,
    utilisateurConnecte,
    utilisateurFetching,
    utilisateurError,
    fonctionsPostesFetching,
    resetPutUtilisateur,
    isChargeClienteleBesse,
    utilisateur,
    selectedAdb,
  } = useModifierUtilisateur();
  const handleSubmit = (values: UtilisateurFormData) => {
    const transformedValues = transformUtilisateurDataToModel(values);

    const params = {
      ...{ username: values.identifiant },
      ...{ body: transformedValues },
    };
    modifierUtilisateur(params);
  };

  const navigate = useNavigate();
  const handlePrecedent = () => {
    navigate("/mes-utilisateurs");
  };

  const handleClose = () => {
    resetPutUtilisateur();
  };
  const renderError = (error: any) => {
    return (
      <Snack
        onClose={handleClose}
        open={true}
        variant="error"
        message={error.message}
      />
    );
  };

  const utilisateurBESSE = utilisateurConnecte?.role === "BESSE";

  const disabled = isChargeClienteleBesse;
  const adbList = renderAdbList(utilisateurConnecte, adbRegroupementList);

  let initialValues;
  if (!utilisateurFetching && utilisateur) {
    initialValues = buildInitialValues(utilisateur);
  }

  if (utilisateurConnecte && adbList && adbList.length > 0) {
    return (
      <Layout title="Modifier utilisateur">
        <div>
          <h2>
            Modifier utilisateur {Libelle.pageUtilisateurs.ajouter.pourAdb}{" "}
            {adbSelectedDetail?.nom}
          </h2>
          <LoadingBoundary
            loading={utilisateurFetching && fonctionsPostesFetching}
            error={fonctionsPostesError}
          >
            <Form
              // keepDirtyOnReinitialize
              validate={(values) => validateForm(values, true)}
              name="modifierUtilisateurForm"
              onSubmit={handleSubmit}
              mutators={{
                ...arrayMutators,
              }}
              initialValues={initialValues}
            >
              {({
                handleSubmit,
                submitting,
                form: {
                  mutators: { push, pop },
                },
                values,
                initialValues,
              }) => (
                <>
                  <UtilisateurAdbForm
                    selectedAdb={selectedAdb}
                    formValues={values}
                    push={push}
                    pop={pop}
                    adbRegroupementList={adbList}
                    onSubmit={handleSubmit}
                    fonctionsPostes={fonctionsPostes}
                    handlePrecedent={handlePrecedent}
                    utilisateurBESSE={utilisateurBESSE}
                    utilisateurConnecte={utilisateurConnecte}
                    isFetching={utilisateurFetching}
                    // initialValues={initialValues}
                    disabled={disabled}
                    isModify={true}
                  />
                  <Grid
                    container
                    justifyContent="flex-end"
                    style={{ marginTop: "12px" }}
                  >
                    {utilisateurError && renderError(utilisateurError)}
                  </Grid>
                </>
              )}
            </Form>
          </LoadingBoundary>
        </div>
      </Layout>
    );
  } else {
    return null;
  }
}

export default ModifierUtilisateurAdb;
